:host {
  --background-color: var(--stzh-homepage-search-background-color, #{$colorSecondary20});

  @media print {
    display: none;
  }

  --grid-template-areas: "search search search search";

  @include mq($from: medium) {
    --grid-template-areas: "search search search search search search search search";
  }

  @include mq($from: large) {
    --column-gap: var(--stzh-homepage-search-grid-gutter-large, 0);
    --grid-template-areas: "search search search search search search . . . . . .";
  }

  @include mq($from: ultra) {
    --column-gap: var(--stzh-homepage-search-grid-gutter-ultra, 0);
  }
}

@keyframes slideIn {
  0% {
    transform: translateX(-50px);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}

.stzh-homepage-search {
  background-color: var(--background-color);

  &__container {
    @include container;
    @include grid;
    @include spaceCurve('padding-top', 'medium');
    @include spaceCurve('padding-bottom', 'medium');

    grid-template-areas: var(--grid-template-areas);

    @include mq($from: large) {
      column-gap: var(--column-gap);
    }
  }

  &__form {
    grid-area: search;
    opacity: 0;
    transform: translateX(-50px);

    animation: slideIn 0.5s ease forwards;
    animation-delay: 0.4s;
  }

  &__search {
    position: relative;
    color: $colorGrey90;
    transition: color $baseTransitionAnimationSpeed;
    cursor: pointer;

    &:hover {
      color: $colorBlack;
    }
  }

  &__search-input {
    width: 100%;
    max-width: 100%;
    background-color: var(--stzh-color-white);
    color: transparent;
    font-family: inherit;
    @include fontSize('milli');
    border: none;
    padding: space('xsmall') space('xsmall') space('xsmall') space('xxxxlarge');
    height: $formInputHeight;

    &:focus {
      color: $colorBlack;
    }

    // prevent ugly autofill background color in chrome
    &:-webkit-autofill {
      background-clip: text;
    }

    // hide search clear icon on chrome
    &[type="search"]::-webkit-search-decoration,
    &[type="search"]::-webkit-search-cancel-button,
    &[type="search"]::-webkit-search-results-button,
    &[type="search"]::-webkit-search-results-decoration {
      -webkit-appearance: none;
    }
  }

  &__search-icon {
    position: absolute;
    top: 50%;
    left: space('small');
    transform: translate(0, -50%);
    transition: transform $baseTransitionAnimationSpeed;
    --color: var(--stzh-color-primary70);
  }
}
